// removed by extract-text-webpack-plugin
module.exports = {"backToTop":"_3auAnGujCb6K3aqhBwZf3A","isActive":"_1bhiWZszlQqQCowPEdDenX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackToTop/BackToTop.css
// module id = 172
// module chunks = 0